<template>
  <div class="container">
    <div class="row align-items-center margin-bottom">
      <div class="col-sm-7 offset-sm-1">
        <h1>Get started with aio*</h1>
        <h2>Sign-up your company now</h2>
      </div>
      <div class="col-sm-3 text-center">
        <a :href="companyRegURL" target="_parent"><img src="@/assets/aio-card.png" class="img-fluid"></a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <a :href="companyRegURL" target="_parent" class="btn btn-primary btn-lg btn-block">Continue to sign up</a>
      </div>
    </div>
    <div class="divider"><h2>Or do you have questions?</h2></div>
    <h4 class="text-center margin-bottom">Enter your details and we will be in touch with you shortly</h4>
    <b-form @submit.prevent="submitForm" ref="form" :validated="validated" novalidate>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label offset-sm-1">First name</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" v-model="registrant.firstName" required>
          <div class="invalid-feedback">First name is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label offset-sm-1">Last name</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" v-model="registrant.lastName" required>
          <div class="invalid-feedback">Last name is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label offset-sm-1">Email</label>
        <div class="col-sm-7">
          <input type="email" class="form-control" v-model="registrant.email" required>
          <div class="invalid-feedback">Valid email address is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label offset-sm-1">Phone</label>
        <div class="col-sm-7">
          <BasePhoneInput v-model="registrant.phoneObj" required/>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label offset-sm-1">What is your role within your company?</label>
        <div class="col-sm-7">
          <BaseSelectOther :data="roleOptions" v-model="registrant.role"/>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label offset-sm-1">How many cards do you need?</label>
        <div class="col-sm-7">
          <input type="number" class="form-control" v-model.number="registrant.noOfCards">
          <div class="invalid-feedback">Please enter a valid number.</div>
        </div>
      </div>
      <div class="form-group row margin-bottom">
        <label class="col-sm-3 col-form-label offset-sm-1">Where did you hear about us?</label>
        <div class="col-sm-7">
          <BaseSelectOther :data="hearAboutOptions" v-model="registrant.hearAbout"/>
        </div>
      </div>
      <div class="row margin-bottom">
        <div class="col">
          <button type="submit" class="btn btn-primary btn-lg btn-block">Tell me more</button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import BasePhoneInput from '@/components/BasePhoneInput'
  import BaseSelectOther from '@/components/BaseSelectOther'
  import countries from '@/utils/countries'
  import EventBus from '@/utils/EventBus'
  import Person from '@/utils/Person'
  import api from '@/utils/api'

  export default {
    components: {
      BasePhoneInput,
      BaseSelectOther
    },
    data () {
      return {
        companyRegURL: process.env.VUE_APP_COMPANY_REG_URL,
        isSubmitting: false,
        hearAbout: '',
        hearAboutOptions: [
          {value: 'internet', displayValue: 'Internet search (Google)'},
          {value: 'email', displayValue: 'Email'},
          {value: 'recommendation', displayValue: 'Personal recommendation'}
        ],
        registrant: this.initRegistrant(),
        roleOptions: [
          {value: 'manager', displayValue: 'Manager / Director'},
          {value: 'finance', displayValue: 'Financial officer'},
          {value: 'hr', displayValue: 'HR officer'},
          {value: 'office-admin', displayValue: 'Assistant / office manager'}
        ],
        validated: false
      }
    },
    methods: {
      initRegistrant () {
        const registrant = new Person()
        registrant.phoneObj = {
          countryISO: 'GB',
          phoneNumber: ''
        }
        return registrant
      },
      submitForm () {
        this.validated = true
        if (this.$refs.form.checkValidity()) {
          const countryCode = countries.find(c => c.iso === this.registrant.phoneObj.countryISO).phone
          this.registrant.phone = `${countryCode} ${this.registrant.phoneObj.phoneNumber}`
          // eslint-disable-next-line
          return api.postEnquiry(this.registrant).then(result => {
            this.validated = false
            this.registrant = this.initRegistrant()
            EventBus.$emit('show-notification', 'success', 'Message was sent successfully. You will receive an confirmation email.')
            // TODO: move on (Calendly date picker for appointment?)
          })
        }
      }
    },
    mounted () {
      this.$emit('show-header', false)
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    margin-top: 60px;
    max-width: 850px;
  }

  .margin-bottom {
    margin-bottom: 30px;
  }

  .divider {
    margin: 80px 0;
    position: relative;
    text-align: center;

    h2 {
      background: #fff;
      color: #8c8b8b;
      display: inline-block;
      margin: 0;
      padding: 0 15px;
    }

    &::before {
      background: #8c8b8b;
      content: '';
      height: 2px;
      left: 0;
      position: absolute;
      right: 0;
      top: 50%;
      z-index: -1;
    }
  }
</style>
